import React, { useState } from 'react';
import { DocumentNode, useQuery } from "@apollo/client";

export const usePaginatedTableRequest = (query: DocumentNode, variables?: Record<string, any> | null) => {
    const [pagination, setPagination] = useState({
        page: 1,
        limit: 10
    })
  
    const { data, loading } = useQuery(query, { 
      variables: {
        ...pagination,
        ...(variables ?? {})
      },
      fetchPolicy: "cache-and-network"
     });

     const isInitialLoading = loading && !data;

     return {
        data,
        pagination,
        setPagination,
        loading: isInitialLoading
     }
}